<template>
  <div>
    <Page
      v-if="!$store.state.isReady"
      :title="$t('Streams')"
    >
      <LoadingLayout></LoadingLayout>
    </Page>
    <router-view
      v-else
      @create="onCreate"
    ></router-view>
  </div>
</template>

<script>
import Vue from 'vue'
import UI from 'fanplayr-ui'
import store from './store.ts'
import {getAccount} from './api/server.ts'
import {translate} from './i18n.ts'

Vue.use(UI)

export default {
  store,
  provide: {
    $t: translate
  },
  props: {
    account: {
      type: Object
    },
    authKey: {
      type: String
    },
    api: {
      type: Object,
      required: true
    },
    currentId: {
      type: Number
    },
    productRecommendations: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentStream() {
      return this.$store.state.currentStream
    }
  },
  watch: {
    currentStream: {
      handler(stream) {
        this.$emit('update:current-id', stream ? stream.id : -1)
      }
    }
  },
  created() {
    this.$store.commit('SET_EXTERNAL_API', this.api)

    this.$watch('$route', () => {
    })

    this.$watch('account', (account) => {
      if (account) {
        this.setAccount(account)
      }
    }, {immediate: true})

    // this.$watch('authKey', (authKey) => {
    //   if (authKey) {
    //     getAccount(authKey)
    //       .then(account => this.setAccount(account))
    //   }
    // }, {immediate: true})

    this.$watch('productRecommendations', (value) => {
      this.$store.commit('SET_PRODUCT_RECOMMENDATIONS', value)
    }, {immediate: true})

    getAccount(this.api)
      .then(account => this.setAccount(account))
  },
  methods: {
    setAccount(account) {
      this.$store.commit('SET_ACCOUNT', account)
    }
  }
}
</script>
